<div class="mb-4">
  <h3 class="text-2xl text-[var(--mat-sys-on-surface)]">Perfil de usuario</h3>
  <p class="text-sm text-[var(--mat-sys-on-surface-variant)]">
    Actualice la información de su cuenta.
  </p>
</div>
<div>
  <store-profile-form></store-profile-form>
</div>
<span
  class="inline-block w-full h-px bg-[var(--mat-sys-surface-container-highest)]"></span>
<div class="my-4">
  <h3 class="text-2xl text-[var(--mat-sys-on-surface)]">
    Cambio de contraseña
  </h3>
  <p class="text-sm text-[var(--mat-sys-on-surface-variant)]">
    Cambia tu contraseña periódicamente para mantener tu cuenta segura.
  </p>
</div>
<div>
  <store-change-password-form></store-change-password-form>
</div>
<span
  class="inline-block w-full h-px bg-[var(--mat-sys-surface-container-highest)]"></span>
<div class="my-4">
  <h1 class="text-2xl text-[var(--mat-sys-on-surface)]">Eliminar cuenta</h1>
  <p class="text-sm text-[var(--mat-sys-on-surface-variant)]">
    Una vez que elimines tu cuenta, perderás todas sus operaciones y demás
    configuraciones. Ten cuidado con esta operación.
  </p>
</div>
<button mat-flat-button (click)="removeCustomer()" class="alert mt-2">
  Eliminar
</button>
